var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLine47(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 77",
    overflow: "scroll",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fillRule: "evenodd",
    fill: "#FF82B4",
    width: 120,
    height: 77
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M55.6391983,55.9336014v12.4443283H43.7871017V55.9336014H16.8666992v-11.089901L40.0625,8.6107998h15.5766983v38.0102997 h7.0268021v9.3125H55.6391983z M43.7871017,19.1084003h-0.1689034c-0.2538986,1.0156002-1.9473,4.6557999-4.3173981,8.3808994 L27.1103992,46.6211014h16.6767025V19.1084003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0683975,68.3779297H69.4394989c0-7.8730278,2.1162033-12.9521294,7.3652039-22.6875305l14.5604935-27.0897999 H62.3280983V8.6107998h41.8203011v9.7354012C91.0263977,41.1190987,83.0683975,58.9813995,83.0683975,68.3779297z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine47);
export default __webpack_public_path__ + "static/media/line-47.3bda781d8bd6c77b611d61deaadeda52.svg";
export { ForwardRef as ReactComponent };